import React, { useEffect, useState } from 'react';
import { Box, Tooltip, Typography, useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { KeyboardCommandKey } from '@mui/icons-material';
import SearchModal from './SearchModal';
import { SEARCH_TEXT } from './constants';

export default function GlobalSearch() {
  const [open, setOpen] = useState(false);
  const isMac = navigator.userAgent.toLocaleLowerCase().includes('mac');
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((isMac && e.metaKey && e.key === 'k') || (!isMac && e.ctrlKey && e.key === 'k')) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Tooltip title={SEARCH_TEXT} arrow placement="bottom">
        <Box
          onClick={handleClick}
          sx={{
            borderRadius: '4px',
            border: '1px solid',
            borderColor: (theme) => theme.palette.grey[500],
            height: '35px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: isSmallScreen ? '100%' : '270px',
            px: 1.5,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          }}
          data-testid="global-search"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
            <Typography variant="subtitle2" sx={{ color: 'grey.500', fontWeight: 400 }}>
              Search
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mr: '5px' }}>
            {isMac ? (
              <KeyboardCommandKey sx={{ color: 'grey.500', fontSize: '16px' }} />
            ) : (
              <Typography variant="subtitle2" sx={{ color: 'grey.500', fontWeight: 500, mr: 0 }}>
                Ctrl+
              </Typography>
            )}
            <Typography variant="subtitle2" sx={{ color: 'grey.500', fontWeight: 500 }}>
              K
            </Typography>
          </Box>
        </Box>
      </Tooltip>
      <SearchModal open={open} onClose={handleClose} />
    </>
  );
}
